export const baseMenuItems = [
    {
        label: 'Правила приема и нормативные документы',
        key: 'app1',
        href: level => `/documents/${level.key}/app1`
    },
    {
        label: 'Информация и документы необходимые для поступления',
        key: 'app2',
        href: level => `/documents/${level.key}/app2`
    },
    {
        label: 'Сроки проведения приема',
        key: 'calendar',
        href: level => `/calendar?level=${level.key}`,
        isExternal: true
    },
    {
        label: 'Направления подготовки и специальности',
        key: 'programs',
        href: '?scrollTo=bachelor',
        changeSelectedProgram: true,
        isExternal: true
    },
    {
        label: 'Вступительные испытания',
        key: 'app3',
        href: level => `/documents/${level.key}/app3`
    },
    {
        label: 'Особые права (льготы)',
        key: 'app4',
        href: level => `/documents/${level.key}/app4`,
        excludeFor: ['phd', 'master']
    },
    {
        label: 'Сведения о ходе приема',
        key: 'app5',
        href: level => `/documents/${level.key}/app5`
    },
    {
        label: 'Платное обучение',
        key: 'app8',
        href: level => `/documents/${level.key}/app8`
    },
    {
        label: 'Целевое обучение',
        key: 'app6',
        href: level => `/documents/${level.key}/app6`,
        excludeFor: ['spo', 'phd']
    },
    {
        label: 'Прием иностранных граждан',
        key: 'app7',
        href: level => `/documents/${level.key}/app7`
    },
    {
        label: 'Общежитие',
        key: 'app9',
        href: level => `/documents/${level.key}/app9`
    },
    {
        label: 'Калькулятор ЕГЭ',
        key: 'calendar',
        href: `/ege-calculator`,
        isExternal: true,
        excludeFor: ['spo', 'master', 'phd']
    },
];

export const generateMenuData = (educationLevels) => {
    return educationLevels.map(level => ({
        id: level._id,
        title: level.label,
        items: baseMenuItems
            .filter(item => !item.excludeFor || !item.excludeFor.includes(level.key))
            .map(item => ({
                ...item,
                href: typeof item.href === 'function' ? item.href(level) : item.href
            }))
    }));
};